import { TFunction } from 'i18next'

export const UNLIMITED_LIMIT_THRESHOLD = 90000

type ReservationConstraints = {
  minimumQuantity?: number
  maximumQuantity?: number
}

export type ConstraintScope =
  | 'total'
  | 'spot'
  | 'groupReservation'
  | 'groupSpot'

const getConstraintKeyPrefix = (scope?: ConstraintScope) =>
  scope ? `tickets.group.constraints.${scope}` : 'tickets.group.constraints'

export function hasConfiguredMinimum(quantity?: number): quantity is number {
  return typeof quantity === 'number' && quantity > 0
}

export function hasConfiguredMaximum(quantity?: number): quantity is number {
  return (
    typeof quantity === 'number' &&
    quantity > 0 &&
    quantity < UNLIMITED_LIMIT_THRESHOLD
  )
}

export function getReservationConstraintMessage(
  t: TFunction,
  constraints: ReservationConstraints,
  scope?: ConstraintScope
): string | null {
  const hasMin = hasConfiguredMinimum(constraints.minimumQuantity)
  const hasMax = hasConfiguredMaximum(constraints.maximumQuantity)

  if (!hasMin && !hasMax) {
    return null
  }

  const keyPrefix = getConstraintKeyPrefix(scope)

  if (hasMin && hasMax) {
    return t(`${keyPrefix}.minAndMax`, {
      max: constraints.maximumQuantity,
      min: constraints.minimumQuantity,
    })
  }

  if (hasMin) {
    return t(`${keyPrefix}.min`, {
      count: constraints.minimumQuantity,
    })
  }

  return t(`${keyPrefix}.max`, {
    count: constraints.maximumQuantity,
  })
}
